import React, {Component} from 'react';
import Checkbox from "./checkbox";
import {Col, Row} from 'react-bootstrap';
import {Field} from 'formik';


export default class Features extends Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(e) {
		this.props.values.key_features[e.target.value] = !(e.target.value in this.props.values.key_features);
		this.props.onChange("key_features", this.props.values.key_features);
	};

	getMapSize(x) {
		let len = 0;
		// eslint-disable-next-line no-unused-vars
		for (let count in x) {
			if (this.props.values.key_features[count] === true) {
				len++;
			}
		}
		return len;
	}

	renderCompressedList() {
		if (this.props.compressedFeatures.length > 0) {
			const disabled = this.getMapSize(this.props.values.key_features) >= 5
			return (
				<div>
					<Row>
						<Col>
							<h4 className="ui centered question-header text-center">
								Which are the most important (up to 5)?
							</h4>
						</Col>
					</Row>
					<Row md="4" sm="2" xs="1">
						{
							this.props.compressedFeatures.map((feature) => {
								return (
									<Field name="key_features" key={feature.value}>
										{({field, form, meta}) => {
											return (
												<Checkbox
													name="key_features"
													identifier={feature.value}
													key={feature.value}
													handleChange={this.handleChange}
													disabled={disabled && (!(feature.value in this.props.values.key_features))}
													{...feature}
												/>
											);
										}}
									</Field>
								)
							})
						}
					</Row>
				</div>
			);
		}
	}

	render() {
		return (
			<div>
				<Row>
					<Col>
						<h4 className="ui centered question-header text-center">What features do you require?</h4>
					</Col>
				</Row>
				<Row md="4" sm="2" xs="1">
					{
						this.props.data.map((feature) => {
							return (
								<Checkbox name="all_features"
										  identifier={feature.id}
										  key={feature.value}
										  handleChange={this.props.featureCompression}
										  {...feature}
								/>
							)
						})
					}
				</Row>
				{this.renderCompressedList()}
			</div>
		)
	}
}
